import './Disclaimer.css';

const Disclaimer = () => {
    return null;
};

export default Disclaimer;
